import { GetAllMuscles, RG_TYPE, DOOR_TYPE, deepFlatChildren, SpaceAccess, roundDecimals } from "@project-rouge/rg-core";
import { getPivotRaw, Vector3toV3, applyTransform, getPivot, V3toVector3, distanceToLine, applyInverseTransform, addOpeningOnClosestPoint } from "@project-rouge/rg-three";
import { Vector3 } from "three";
import { getDoorType } from "./index62.js";
import { sort2dObjsbyVector } from "./index158.js";
function addDoorsToTechnicalSpaces({ building, dataset }) {
  const rvData = dataset.rvData;
  const singleDoorId = dataset.modulousIds.techSpaceSingleDoorId;
  const doubleDoorId = dataset.modulousIds.techSpaceDoubleDoorId;
  const allMuscles = GetAllMuscles(building.data.anatomy);
  const techSpaces = building.children.filter((c) => c.type === RG_TYPE.TechnicalSpace);
  for (const techSpace of techSpaces) {
    const doorType = getDoorType(techSpace);
    const modulousId = doorType === DOOR_TYPE.Double ? doubleDoorId : singleDoorId;
    const muscle = allMuscles.filter((m) => m.id === techSpace.data.muscleID)[0];
    const tendon = muscle.bone.tendon;
    const corridor = building.children.find((c) => c.type === RG_TYPE.Corridor && c.data.tendonID === tendon.id && c.data.level === techSpace.data.level);
    const centerline = [
      getPivotRaw([0, 0, 0.5], corridor),
      getPivotRaw([1, 0, 0.5], corridor)
    ];
    let targetModule;
    const techSpaceModules = techSpace.children.filter((c) => c.type === RG_TYPE.Module);
    if (techSpaceModules.length === 1)
      targetModule = techSpaceModules[0];
    else {
      const corridorVec = [centerline[1][0] - centerline[0][0], centerline[1][2] - centerline[0][2]];
      const sortedModules = sort2dObjsbyVector(techSpaceModules, corridorVec, (p) => Vector3toV3(applyTransform(p, techSpace)));
      targetModule = sortedModules[Math.floor(sortedModules.length * 0.5)];
    }
    const floorHeight = Math.max(...deepFlatChildren(targetModule).filter((c) => c.type === RG_TYPE.Floor).map((f) => f.pos[1]));
    const heightPivot = (floorHeight + targetModule.anchor[1] * targetModule.size[1]) / targetModule.size[1];
    let refPoint;
    const access = techSpace.data.instance.attributes.access;
    if (access === SpaceAccess.Street) {
      refPoint = getPivot([0.5, heightPivot, 1], targetModule);
    } else {
      const pivot = getPivot([0.5, heightPivot, 0], targetModule);
      const pivotOnBuilding = V3toVector3(applyTransform(pivot, techSpace));
      const { closest } = distanceToLine(pivotOnBuilding, centerline);
      const v1 = closest.sub(pivotOnBuilding);
      const v2 = new Vector3().fromArray(centerline[1]).sub(new Vector3().fromArray(centerline[0])).setY(0);
      if (Math.abs(roundDecimals(v1.dot(v2))) !== 0) {
        const corridorIndex = pivotOnBuilding.distanceToSquared(new Vector3().fromArray(centerline[0])) < pivotOnBuilding.distanceToSquared(new Vector3().fromArray(centerline[1])) ? 0 : 1;
        const corridorRef = centerline[corridorIndex];
        const corridorRefOnModule = applyInverseTransform([corridorRef[0], corridorRef[1], corridorRef[2]], techSpace);
        refPoint = new Vector3(corridorRefOnModule[0], pivot.y, corridorRefOnModule[2]);
      } else {
        refPoint = pivot.clone();
      }
      addOpeningOnClosestPoint({ obj: targetModule, modulousId, rvDataList: rvData, type: RG_TYPE.Door, point: applyInverseTransform(refPoint, targetModule), isEntrance: true });
    }
  }
}
export {
  addDoorsToTechnicalSpaces
};
//# sourceMappingURL=index27.js.map
